"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ProductListingSection;
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@linaria/react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _base = require("@site/pattern-library-utils/base.functions");
var _content = require("@site/pattern-library-utils/content");
var _tracking = require("@site/pattern-library-utils/tracking");
var _productListingContext = require("./product-listing-context");
var _productTileGrid = _interopRequireDefault(require("./product-tile-grid"));
var _filters = _interopRequireDefault(require("./filters"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable max-statements */

const ProductListingPageContainer = /*#__PURE__*/(0, _react2.styled)("section")({
  name: "ProductListingPageContainer",
  class: "pl-p14ohkkw"
});
const Heading = /*#__PURE__*/(0, _react2.styled)("h1")({
  name: "Heading",
  class: "pl-h1hs9xtu"
});
const Content = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Content",
  class: "pl-c1e8im6e"
});

/**
 * @module ProductListingSection
 * @param {string} title heading for the section
 * @param {object} categorySection category section object
 * @param {number} tilesPerPage number of tiles to display per page
 * @param {string} ctaTileText text for CTA tile
 * @param {string} showingTileText text for the showing tile
 * @param {string} baseUrl base url for the product listing page
 * @returns {React.ReactElement} ProductListingSection
 * @public
 */
function ProductListingSection({
  title,
  categoryFilterLabel,
  businessFilterLabel,
  tagFilterLabel,
  mobileFilterOpenCtaText,
  mobileFilterApplyCtaText,
  mobileFilterHeading,
  categoryTotalTileText,
  categorySection,
  tilesPerPage,
  ctaTileText,
  showingTileText,
  baseUrl,
  initialCategory
}) {
  const categories = categorySection.categoryItems;
  const foundCategory = categories.find(category => category.name?.Text.toLowerCase() === initialCategory?.toLowerCase());
  const [activeCategory, setActiveCategory] = (0, _react.useState)(foundCategory || categories[0]);
  const [productTiles, setProductTiles] = (0, _react.useState)(foundCategory?.productTiles || categories[0]?.productTiles);
  const [isLoading, setLoading] = (0, _react.useState)(false);
  const [tags, setTags] = (0, _react.useState)([]);
  const [businesses, setBusinesses] = (0, _react.useState)([]);
  const [userInteracted, setUserInteracted] = (0, _react.useState)(true);

  // Tracking attributes, requires specific formatting
  const [dataCategory, setDataCategory] = (0, _react.useState)('category_' + (0, _tracking.applySnakeCase)(activeCategory._name));
  const [dataTags, setDataTags] = (0, _react.useState)([]);
  const [dataBusiness, setDataBusiness] = (0, _react.useState)([]);
  const [selectorCustomProperties, setSelectorCustomProperties] = (0, _react.useState)({
    plp_category_selected: dataCategory,
    plp_tags_selected: dataTags,
    plp_business_selected: dataBusiness
  });

  // ========================
  // === State management ===
  // ========================

  const setFilters = tiles => {
    const newTags = [];
    const newBusinesses = [];
    tiles.forEach(tile => {
      tile.productTags?.forEach(tag => {
        const tagMatch = newTags.find(t => t.tagName.Text === tag.tagName.Text);
        if (tagMatch) {
          tagMatch.count += 1;
        } else {
          tag.count = 1;
          tag.isActive = false;
          newTags.push(tag);
        }
      });
      tile.businessType?.forEach(business => {
        const businessMatch = newBusinesses.find(b => b.businessName.Text === business.businessName.Text);
        if (!businessMatch) {
          business.isActive = false;
          newBusinesses.push(business);
        }
      });
    });
    setTags(newTags);
    setBusinesses(newBusinesses);
  };
  const isLoadedProductTile = tile => {
    return tile?.variant;
  };
  const fetchProductTiles = async () => {
    setLoading(true);
    const market = (0, _base.getCookieValue)('market') || 'en-US';
    const tiles = await Promise.all(activeCategory.productTiles?.map(async tile => {
      if (isLoadedProductTile(tile)) {
        return tile;
      }
      const storageKey = `${tile.id}_${market}`;
      const storageItem = sessionStorage.getItem(storageKey);
      if (storageItem) {
        return (0, _content.parseContentItem)(JSON.parse(storageItem));
      }
      const contentItem = await (0, _content.getContentItembyID)(tile.id, false, false, baseUrl);
      sessionStorage.setItem(storageKey, JSON.stringify(contentItem));
      return (0, _content.parseContentItem)(contentItem);
    }));
    setProductTiles(tiles);
    setFilters(tiles);
    setLoading(false);
  };
  const updateActiveCategoryFromURL = (0, _react.useCallback)(() => {
    let categoryMatch;
    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);
      const currentCategoryParam = urlParams.get('category')?.toLowerCase();
      if (currentCategoryParam) {
        categoryMatch = categories.find(category => category.name?.Text.toLowerCase() === currentCategoryParam);
      }
    }
    setActiveCategory(categoryMatch || categories[0]);
  }, [categories]);
  (0, _base.useIsomorphicLayoutEffect)(() => {
    updateActiveCategoryFromURL();
  }, [updateActiveCategoryFromURL]);
  (0, _react.useEffect)(() => {
    if (activeCategory) {
      const handlePopState = () => {
        updateActiveCategoryFromURL();
      };
      window.addEventListener('popstate', handlePopState);
      return () => {
        window.removeEventListener('popstate', handlePopState);
      };
    }
  }, [activeCategory, updateActiveCategoryFromURL]);

  // Get productTiles, tileCount and tags assoicated with active category
  (0, _base.useIsomorphicLayoutEffect)(() => {
    if (activeCategory?.productTiles) {
      if (activeCategory.productTiles.some(tile => !isLoadedProductTile(tile))) {
        setBusinesses([]);
        setTags([]);
        fetchProductTiles();
      } else {
        setProductTiles(activeCategory.productTiles);
        setFilters(activeCategory.productTiles);
        setLoading(false);
      }
    }
    setSelectorCustomProperties({
      plp_category_selected: dataCategory,
      plp_tags_selected: dataTags,
      plp_business_selected: dataBusiness
    });
    setDataCategory('category_' + (0, _tracking.applySnakeCase)(activeCategory._name));
  }, [activeCategory]);
  const tileGridRef = (0, _react.useRef)(null);
  const [containerHeight, setContainerHeight] = (0, _react.useState)('auto');
  const [lastIndex, setLastIndex] = (0, _react.useState)(Math.min(productTiles.length, tilesPerPage));
  const {
    width
  } = (0, _base.useWindowSize)();
  const updateContainerHeight = (0, _react.useCallback)(() => {
    if (tileGridRef.current) {
      const height = tileGridRef.current.offsetHeight;
      const offsetBottom = 100;
      const hasCtaOffsetBottom = 200;
      const expectedTilesPerPage = 9;
      const newHeight = height + (productTiles.length > expectedTilesPerPage && lastIndex < productTiles.length ? hasCtaOffsetBottom : offsetBottom);
      setContainerHeight(`${newHeight}px`);
    }
  }, [productTiles, lastIndex]);
  (0, _react.useLayoutEffect)(() => {
    if (width >= _breakpoints.size.laptopMd) {
      const frameId = requestAnimationFrame(updateContainerHeight);
      return () => {
        cancelAnimationFrame(frameId);
      };
    }
  }, [width, updateContainerHeight]);
  return /*#__PURE__*/_react.default.createElement(_productListingContext.ProductListingContext.Provider, {
    value: {
      categories,
      activeCategory,
      setActiveCategory,
      setProductTiles,
      productTiles,
      tags,
      setTags,
      businesses,
      setBusinesses,
      setDataBusiness,
      setDataTags,
      dataCategory,
      dataTags,
      dataBusiness,
      userInteracted,
      setUserInteracted,
      selectorCustomProperties,
      setSelectorCustomProperties
    }
  }, /*#__PURE__*/_react.default.createElement(ProductListingPageContainer, {
    "data-cy": "product-listing-section",
    "data-category": isLoading || !productTiles ? '' : dataCategory,
    "data-tags": isLoading || !productTiles ? '' : dataTags,
    "data-business": isLoading || !productTiles ? '' : dataBusiness
  }, /*#__PURE__*/_react.default.createElement(Heading, {
    "data-cy": "plp-title"
  }, title?.Text), /*#__PURE__*/_react.default.createElement(Content, null, /*#__PURE__*/_react.default.createElement(_filters.default, {
    categoryFilterLabel: categoryFilterLabel?.Text,
    businessFilterLabel: businessFilterLabel?.Text,
    tagFilterLabel: tagFilterLabel?.Text,
    mobileFilterOpenCtaText: mobileFilterOpenCtaText?.Text,
    mobileFilterApplyCtaText: mobileFilterApplyCtaText?.Text,
    mobileFilterHeading: mobileFilterHeading?.Text,
    categoryTotalTileText: categoryTotalTileText?.Text
  }), /*#__PURE__*/_react.default.createElement(_productTileGrid.default, {
    tilesPerPage: tilesPerPage,
    isLoading: isLoading,
    ctaTileText: ctaTileText,
    showingTileText: showingTileText,
    tileGridRef: tileGridRef,
    containerHeight: containerHeight,
    lastIndex: lastIndex,
    setLastIndex: setLastIndex
  }))));
}
ProductListingSection.propTypes = {
  title: _propTypes.default.shape({
    Text: _propTypes.default.string
  }),
  businessFilterLabel: _propTypes.default.object,
  categoryFilterLabel: _propTypes.default.object,
  tagFilterLabel: _propTypes.default.object,
  mobileFilterOpenCtaText: _propTypes.default.object,
  mobileFilterApplyCtaText: _propTypes.default.object,
  mobileFilterHeading: _propTypes.default.object,
  categoryTotalTileText: _propTypes.default.object,
  categorySection: _propTypes.default.shape({
    categoryItems: _propTypes.default.arrayOf(_propTypes.default.shape({
      id: _propTypes.default.string,
      name: _propTypes.default.shape({
        Text: _propTypes.default.string
      }),
      icon: _propTypes.default.string,
      categoryType: _propTypes.default.oneOf([_productListingContext.categoryTypes.BUNDLE, _productListingContext.categoryTypes.PRODUCT]),
      flagText: _propTypes.default.string,
      productTiles: _propTypes.default.arrayOf(_propTypes.default.shape({
        _name: _propTypes.default.string,
        id: _propTypes.default.string,
        variant: _propTypes.default.string,
        isFeaturedProductTile: _propTypes.default.bool,
        featuredCategory: _propTypes.default.shape({
          Text: _propTypes.default.string
        }),
        gridIndex: _propTypes.default.number
      }))
    }))
  }),
  tilesPerPage: _propTypes.default.number,
  ctaTileText: _propTypes.default.string,
  showingTileText: _propTypes.default.string,
  baseUrl: _propTypes.default.string,
  initialCategory: _propTypes.default.string
};